import { createSlice } from "@reduxjs/toolkit";
const initialValue = window.localStorage.getItem("selectedLanguage") || "en";
const languageSlice = createSlice({
  name: "language",
  initialState: {
    value: initialValue,
  },
  reducers: {
    language: (state, { payload }) => {
      state.value = payload;
    },
  },
});
export const setLanguage =
  (languageChanged = "en") =>
  async (dispatch) => {
    dispatch(language(languageChanged));
    window.localStorage.setItem("selectedLanguage", languageChanged);
  };
export const languageSelector = (state) => state.language;
export const { language } = languageSlice.actions;
export default languageSlice.reducer;
